export default ({ data }, { market, t }) => ({
  title: t('meta', 'landing.title'),
  description: t('meta', 'landing.description'),
  canonical: market.domain,
  openGraph: [
    {
      key: 'title',
      content: t('meta', 'company.name'),
    },
    { key: 'type', content: 'website' },
    data.categoryTree &&
      data.categoryTree[0] && {
        key: 'image',
        content: data.categoryTree[0].logo,
      },
    { key: 'url', content: market.domain },
  ].filter(x => x),
});
